export default __webpack_public_path__ + "static/media/check-circle.f85666e9.svg";